import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from 'components'

const FooterMinimal = () => {
  const data = useStaticQuery(graphql`
    {
      wpMenu(name: { eq: "simple" }) {
        menuItems {
          nodes {
            id
            label
            parentId
            path
            childItems {
              nodes {
                id
                label
                path
              }
            }
          }
        }
      }
    }
  `)
  return (
    <div className="container py-8">
      <ul className="flex items-center justify-center ">
        {(data.wpMenu.menuItems.nodes || []).map(({ id, label, path }) => {
          return (
            <li
              data-id={id}
              key={id}
              className="button button--text font-normal text-gray-400 hover:underline"
            >
              <Link to={path}>{label}</Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default FooterMinimal
